import { Col, Row } from "react-bootstrap";
import Helper from "../../oversight-core/utils/helpers";
import styles from "./site-pie-chart-labels.module.scss";

interface ILabels {
  percentage: number;
  value: number;
  color: string;
}

interface IProps {
  labels: ILabels[];
}

const SitePieChartLabels = (props: IProps) => {
  const { labels } = props;

  return (
    <>
      {labels.map((label, index) => {
        return (
          <Row
            key={index}
            className="align-items-center font-weight-400 font-size-12 mb-1"
          >
            <Col
              className="col-auto font-weight-500 pe-0"
              style={{ width: "40px", color: label.color }}
            >
              {label.percentage}%
            </Col>
            <Col className={`col-auto ${styles.letterSpace} text-light ps-1`}>
              {Number(Helper.roundTo2(label.value))}&nbsp;kwh
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default SitePieChartLabels;
